import React, { useState } from "react";
import NavFA from "../NavFA";
import Footer from "../Footer";
import PageFAbody from "../PageFAbody";

export default function PageFA() {
    const [view, setView] = useState('orders'); // Default view is 'orders'

    // Function to change the view based on the button clicked
    const handleViewChange = (newView) => {
        setView(newView);
    };

    return (
        <div>
            <NavFA onViewChange={handleViewChange} /> {/* Pass the handler to NavFA */}
            <PageFAbody view={view} /> {/* Pass the current view to PageFAbody */}
            <Footer />
        </div>
    );
}
